<template>
    <div
        class="mt-1"
        v-if="text"
    >
        <ion-text
            color="danger"
            class="fs-14"
            >{{ text }}</ion-text
        >
    </div>
</template>

<script setup lang="ts">
    import { IonText } from '@ionic/vue';
    import { defineProps } from 'vue';

    defineProps({
        text: {
            type: String,
        },
    });
</script>
